function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
export * from "./CSSEditorSection";
import PropertyButton from "./PropertyButton";
import PropertyLabel from "./PropertyLabel";
import PropertyRow from "./PropertyRow";
import { PropertyButtonV2 } from "../PropertyButtonV2";
export const CSSProperty = {
    Button: PropertyButton,
    Label: PropertyLabel,
    Row: PropertyRow
};
export const CSSPropertyEditor = ({ label, node, property, baseType, useValueEditingComponent, useValueEditingProps, useButtonEditingProps, styling: { $flipX } = {} })=>{
    var _valueProps_value, _valueProps_value1, _valueProps_value2, _valueProps_value3;
    const buttonProps = useButtonEditingProps({
        node,
        property
    });
    const _valueProps = useValueEditingProps({
        node,
        property
    });
    const { onClickValue } = _valueProps, valueProps = _object_without_properties(_valueProps, [
        "onClickValue"
    ]);
    const type = ((_valueProps_value = valueProps.value) === null || _valueProps_value === void 0 ? void 0 : _valueProps_value.type) || (baseType === null || baseType === void 0 ? void 0 : baseType.type) || "css-string";
    const ValueEditingComponent = useValueEditingComponent({
        type: ((_valueProps_value1 = valueProps.value) === null || _valueProps_value1 === void 0 ? void 0 : _valueProps_value1.type) || (baseType === null || baseType === void 0 ? void 0 : baseType.type) || "css-string",
        cssEnumHint: (valueProps === null || valueProps === void 0 ? void 0 : (_valueProps_value2 = valueProps.value) === null || _valueProps_value2 === void 0 ? void 0 : _valueProps_value2.type) === "css-string" ? valueProps === null || valueProps === void 0 ? void 0 : (_valueProps_value3 = valueProps.value) === null || _valueProps_value3 === void 0 ? void 0 : _valueProps_value3.cssEnumHint : baseType === null || baseType === void 0 ? void 0 : baseType.cssEnumHint
    });
    return /*#__PURE__*/ _jsx(CSSProperty.Row, {
        $flipX: $flipX,
        $size: "lg",
        children: $flipX ? /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                /*#__PURE__*/ _jsx(CSSProperty.Row.Options, {
                    readOnly: valueProps.readOnly,
                    onClick: onClickValue,
                    children: /*#__PURE__*/ _jsx(ValueEditingComponent, _object_spread({}, valueProps))
                }),
                /*#__PURE__*/ _jsx(CSSProperty.Row.Label, {
                    children: /*#__PURE__*/ _jsx(PropertyButtonV2, {
                        label: label,
                        value: buttonProps.value,
                        isDynamic: buttonProps.isDynamic,
                        onOptionClick: buttonProps.openConditionalEditor,
                        onCommandClick: ()=>{
                            var _buttonProps_clearValue;
                            (_buttonProps_clearValue = buttonProps.clearValue) === null || _buttonProps_clearValue === void 0 ? void 0 : _buttonProps_clearValue.call(buttonProps);
                        },
                        menuActions: buttonProps.dropdownOptions
                    })
                })
            ]
        }) : /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                /*#__PURE__*/ _jsx(CSSProperty.Row.Label, {
                    children: /*#__PURE__*/ _jsx(PropertyButtonV2, {
                        label: label,
                        value: buttonProps.value,
                        isDynamic: buttonProps.isDynamic,
                        onOptionClick: buttonProps.openConditionalEditor,
                        onCommandClick: ()=>{
                            var _buttonProps_clearValue;
                            (_buttonProps_clearValue = buttonProps.clearValue) === null || _buttonProps_clearValue === void 0 ? void 0 : _buttonProps_clearValue.call(buttonProps);
                        },
                        menuActions: buttonProps.dropdownOptions
                    })
                }),
                /*#__PURE__*/ _jsx(CSSProperty.Row.Options, {
                    readOnly: valueProps.readOnly,
                    onClick: onClickValue,
                    children: /*#__PURE__*/ _jsx(ValueEditingComponent, _object_spread({}, valueProps))
                })
            ]
        })
    });
};
export const CSSLiteralEditor = ({ label, node, property, baseType, useValueEditingComponent, useValueEditingProps })=>{
    var _valueProps_value, _valueProps_value1, _valueProps_value2, _valueProps_value3;
    const _valueProps = useValueEditingProps({
        node,
        property
    });
    const { onClickValue } = _valueProps, valueProps = _object_without_properties(_valueProps, [
        "onClickValue"
    ]);
    const type = ((_valueProps_value = valueProps.value) === null || _valueProps_value === void 0 ? void 0 : _valueProps_value.type) || (baseType === null || baseType === void 0 ? void 0 : baseType.type) || "css-string";
    const ValueEditingComponent = useValueEditingComponent({
        type: ((_valueProps_value1 = valueProps.value) === null || _valueProps_value1 === void 0 ? void 0 : _valueProps_value1.type) || (baseType === null || baseType === void 0 ? void 0 : baseType.type) || "css-string",
        cssEnumHint: (valueProps === null || valueProps === void 0 ? void 0 : (_valueProps_value2 = valueProps.value) === null || _valueProps_value2 === void 0 ? void 0 : _valueProps_value2.type) === "css-string" ? valueProps === null || valueProps === void 0 ? void 0 : (_valueProps_value3 = valueProps.value) === null || _valueProps_value3 === void 0 ? void 0 : _valueProps_value3.cssEnumHint : baseType === null || baseType === void 0 ? void 0 : baseType.cssEnumHint
    });
    return /*#__PURE__*/ _jsx(CSSProperty.Row, {
        $size: "lg",
        children: /*#__PURE__*/ _jsx(CSSProperty.Row.Options, {
            readOnly: valueProps.readOnly,
            onClick: onClickValue,
            children: /*#__PURE__*/ _jsx(ValueEditingComponent, _object_spread({}, valueProps))
        })
    });
};
